<!-- <p>data-integrations-detail works!</p> -->
<div class="pageContainer">
	<div class="tab-wrapper" *ngIf="selectedIntegration">
		<nav class="navbar navbar-expand-lg alignRow" style="margin-top: var(--default-margin);">
			<span class="alignRow app-icon app-icon--webhook"><mat-icon /></span>
			<span style="padding-left: var(--default-padding);font-weight: bold;font-size: larger;">
				{{selectedIntegration.Description}}</span>
			<span class="me-auto"></span>
		</nav>
		<ejs-tab #pageTabs id="element" [height]="'100%'" [selectedItem]="selectedTabIndex"
			(selected)="onChange($event)">
			<e-tabitems>
				<!-- Webhook Information Tab -->
				<e-tabitem>
					<ng-template #headerText>
						<span class="alignRow">
							<mat-icon>info</mat-icon>
							<span>&nbsp;Details</span>
						</span>
					</ng-template>

					<ng-template #content>
						<div class="detail-tab-content">
							<ng-component *ngIf="selectedIntegration then headerTemplate" />
						</div>
					</ng-template>
				</e-tabitem>

				<!-- Sensors Tab -->
				<e-tabitem>
					<ng-template #headerText>
						<span class="alignRow">
							<mat-icon>sensors</mat-icon>
							<span>&nbsp;Sensors</span>
						</span>
					</ng-template>

					<ng-template #content>
						<div class="sensor-tab-content">
							<app-data-integrations-sensors/>
						</div>
					</ng-template>
				</e-tabitem>

				<!-- Neuron Sensors Info Tab -->
				<e-tabitem *ngIf="isNeuronSensor">
					<ng-template #headerText>
						<span class="alignRow">
							<img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/neuron-board-icon.ico"
								class="neuron-icon">
							<span>&nbsp;Neuron Sensor Info</span>
						</span>
					</ng-template>

					<ng-template #content>
						<div class="neuron-tab-content">
							<app-data-integrations-neuronsensors class="neuron-sensor-component" />
						</div>
					</ng-template>
				</e-tabitem>

			</e-tabitems>
		</ejs-tab>
	</div>
</div>

<ng-template #headerTemplate>
	<ng-container *ngIf="selectedIntegration">
		<nav class="navbar navbar-expand-lg alignRow" style="margin-top: var(--default-margin);">
			<span class="alignRow app-icon app-icon--webhook"><mat-icon /></span>
			<span style="padding-left: var(--default-padding);font-weight: bold;font-size: larger;">Integration
				Details</span>
			<span class="me-auto"></span>
		</nav>
		<div class="tableDiv" [ngStyle]="{'background-color': (selectedIntegration.Enabled == true) ? '': 'lightpink'}">
			<table class="detailTable" >
				<colgroup>
					<col style="width: 125px;">
					<col style="width: 50px;">
					<col style="width: 80px;">
					<col style="width: 100px;">
					<col style="width: auto">
					<col style="width: 50px;">
				</colgroup>

				<tr>
					<th>Account:</th>
					<td colspan="5">{{selectedIntegration.AccountName}}</td>
				</tr>
				<tr>
					<th>Site:</th>
					<td colspan="5">{{selectedIntegration.OrganisationName}}</td>
				</tr>
				<tr>
					<th>ClientWebhookID:</th>
					<td colspan="5"><span style="margin-right: 1em;"
							title="Last Received Data: {{convertEpoch(selectedIntegration.LastValueReceived)}}">{{selectedIntegration.ClientWebhookID}}</span>
					</td>
					
				</tr>				
				<tr>
					<th>Type</th>
					<td colspan="3">{{selectedIntegration.TypeDescription}}</td>
					<td colspan="2">
						<span [ngSwitch]="ValidateNeuron(selectedIntegration)" *ngIf="selectedIntegration.NeuronSensors">
							<span class="app-icon app-icon--warning" *ngSwitchCase="'Warning'"
								style="color: gold; background-color: whitesmoke;"><mat-icon
									title="NeuronSensor Integration has Errors" /> </span>
							<span class="app-icon app-icon--warning" *ngSwitchCase="'Disabled'"
								style="color: red; background-color: whitesmoke;"><mat-icon
									title="NeuronSensor Integration is disabled" /> </span>
							<!-- <span *ngSwitchDefault>OK</span> -->
						</span>
					</td>
				</tr>
				<tr>
					<th>Description</th>
					<td colspan="5">{{selectedIntegration.Description}}</td>
				</tr>
				<tr>
					<th>Last Data</th>
					<td colspan="5">{{convertEpoch(selectedIntegration.LastValueReceived)}}</td>
				</tr>
				<tr>
					<th>Sensors</th>
					<td>{{selectedIntegration.SensorCount}}</td>
					<th>Online</th>
					<td>{{selectedIntegration.SensorOnlineCount}}</td>
					<td colspan="2">&nbsp;</td>
				</tr>
				<tr>
					<th>Datapoints</th>
					<td>{{selectedIntegration.DatapointCount}}</td>
					<th>Online</th>
					<td>{{selectedIntegration.DatapointOnlineCount}}</td>
					<td colspan="2">&nbsp;</td>
				</tr>
				<tr>
					<th>Enabled</th>
					<td >
						<span style="padding:5px; border-radius: 5px;margin: 5px;"
						[ngStyle]="{'background-color': (selectedIntegration.Enabled  == true) ? 'lightgreen':'lightsalmon'}">{{selectedIntegration.Enabled ? 'Yes': 'No'}}</span>
					</td>
					<th>Auto Build</th>
					<td colspan="2" >
						<span style="padding:5px; border-radius: 5px;margin: 5px;"
							[ngStyle]="{'background-color': (selectedIntegration.AutoBuild  == true) ? 'lightgreen':'lightsalmon'}">{{selectedIntegration.AutoBuild ? 'Yes': 'No'}}</span>
					</td>
				</tr>
				<tr>
					<th>Path:</th>
					<td colspan="4">
						<span title="{{selectedIntegration.FQN}}?code={{selectedIntegration.TypeAzureCode}}">
							<span style="padding:0px">{{selectedIntegration.FQN}}</span>
							<span style="padding:0px"
								*ngIf="selectedIntegration.TypeAzureCode">?code={{selectedIntegration.TypeAzureCode}}</span>
						</span>
					</td>
					<td>
						<span class="gridClipboard" title="Copy Path to Clipboard"
							(click)="copyToClipboard(selectedIntegration)">
							<mat-icon>content_copy</mat-icon>
							&nbsp;
						</span>
					</td>
				</tr>
			</table>
			<div class="editDiv">
				<button mat-raised-button type="button" color="primary"
					(click)="editIntegration(selectedIntegration)">Edit</button>
			</div>
		</div>
		<nav class="navbar navbar-expand-lg alignRow" style="margin-top: var(--default-margin);">
			<span class="alignRow app-icon app-icon--webhook"><mat-icon /></span>
			<span style="padding-left: var(--default-padding);font-weight: bold;font-size: larger;">Event
				History</span>
			<span class="me-auto"></span>
		</nav>
		<div class="eventHistory">
			
		</div>
	</ng-container>
</ng-template>